<template>
  <div class="ge-candidates-container">
    <div :class="constituencyContainerClass(currentConstituency.seats)">
      <!-- <div class="constituency-headline">
        <h3 v-html="currentConstituency.name"></h3>
        <span v-html="currentConstituency.typeString"></span>
      </div> -->

      <div class="party-section">
        <div class="party-container" v-for="(party, j) in sortedParties(currentConstituency.incumbentKey, currentConstituency.parties)" :key="j">
          <div class="party-headline">
            <img :src="`${imagesAssetFolder}/party-logos/${party.initial}.svg`" :alt="party.initial">
            <div class="party-headline-text">
              <span class="party" v-html="party.initial"></span>
              <span class="walkover" v-if="currentConstituency.walkover && j === 0">Walkover</span>
            </div>
          </div>

          <div ref="partyMemberWrapper" class="party-member-wrapper">
            <div class="party-member" v-for="(member, k) in party.members[currentConstituency.name]" :key="k">
              <div class="profile-pic" :style="profilePicStyle">
                <img :src="`${imagesAssetFolder}/candidates/${member['photos-ok'] || 'anonymous.jpg'}`" :alt="member.candidate_name">
                <span v-if="member['newcomer'] === 'Y'" :style="{backgroundColor: '#1d315c'}">NEW</span>
              </div>
              <p v-html="member.candidate_name"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {store} from '../store-constituency'
import {imagesAssetFolder} from '../tools/variables'

export default {
  props: ['attributes'],
  computed: {
    imagesAssetFolder () {
      return imagesAssetFolder
    },
    currentConstituency () {
      return store.currentConstituency
    },
    headline () {
      const targetParty = store.parties[this.previousCandidate.party]
      const targetConstituency = this.previousCandidate.constituency
      const candidateText = store.constituencies[targetConstituency].seats > 1 ? 'candidates' : 'candidate'
      return `${(targetParty && targetParty.initial) || 'IND'} ${candidateText} for ${targetConstituency}`
    }
  },
  data () {
    return {
    }
  },
  methods: {
    constituencyContainerClass (seats) {
      return {
        'constituency-container': true,
        [seats > 1 ? 'GRC' : 'SMC']: true
      }
    },
    sortedParties (incumbentKey, parties) {
      return Object.keys(parties)
        .sort()
        .map(partyKey => {
          return {
            ...parties[partyKey],
            orderIndex: parties[partyKey].initial === 'IND' ? '0' : (incumbentKey === parties[partyKey].initial ? 2 : 1)
          }
        })
        .sort((a, b) => b.orderIndex - a.orderIndex)
    },
    profilePicStyle () {
      return {
        pointerEvents: this.showPopUp ? 'all' : 'none',
        cursor: this.showPopUp ? 'pointer' : 'default'
      }
    }
  }
}
</script>

<style lang="scss">
.ge-candidates-container {
  position: relative;

  .constituency-container {
    /* margin-bottom: 40px;
    border-bottom: 1px dotted $greydark; */

    &.GRC {
      .party-member-wrapper {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-wrap: wrap;

        & > * {
          max-width: 140px;
        }

        @include breakpoint(500px) {
          flex-wrap: nowrap;
          justify-content: left;
        }
      }
    }

    &.SMC {
      .party-section {
        display: flex;
        align-items: stretch;
        justify-content: center;

        & > * {
          max-width: 140px;
        }

        @include breakpoint(500px) {
          justify-content: left;
        }

        .party-container .party-headline .party-headline-text > span {
          display: block;
          padding-left: 0;

          @include breakpoint($d_small) {
            display: block;
            padding-left: 0;
          }
        }
      }
    }

    .constituency-headline {
      padding-bottom: 20px;
      & > * {
        display: inline-block;
        padding-right: 10px;
        vertical-align: bottom;
      }

      & > h3 {
        line-height: 22px;
      }

      & > span {
        font-family: $font-CuratorRegular;
        font-size: 15px;
        line-height: 1.3;
      }
    }

    .party-container {
      padding: 0 0 20px;

      .party-headline {
        padding-bottom: 10px;
        white-space: nowrap;

        & > * {
          display: inline-block;
          vertical-align: middle;
        }

        & > img {
          width: 40px;
          height: 40px;
          padding-right: 5px;
        }

        .party-headline-text {
          span {
            display: inline-block;
            vertical-align: middle;

            &.party {
              font-family: $font-CuratorBold;
              line-height: 1;
            }

            &.walkover,
            &.incumbent {
              font-family: $font-CuratorRegular;
              font-size: 13px;
              padding-left: 5px;

              @include breakpoint($d_small) {
                font-size: 15px;
                padding-left: 8px;
              }
            }
          }
        }
      }

      .party-member-wrapper {
        .party-member {
          text-align: center;
          vertical-align: top;
          box-sizing: border-box;
          margin-bottom: 10px;

          @include breakpoint(500px) {
            margin-bottom: 0;
          }

          & > * {
            display: block;
          }

          .profile-pic {
            position: relative;

            img {
              width: calc(100% - 30px);
              vertical-align: bottom;
              border-radius: 50%;
            }

            span {
              position: absolute;
              bottom: 0;
              right: 0;
              font-family: $font-CuratorBold;
              font-size: 13px;
              line-height: 1;
              background-color: black;
              color: #FFFFFF;
              padding: 5px;
              border-radius: 20px;

              @include breakpoint($d_small) {
                font-size: 15px;
                bottom: 6%;
                right: 6%;
              }
            }
          }

          p {
            font-family: $font-CuratorRegular;
            font-size: 15px;
            line-height: 1.3;

            @include breakpoint($d_medium) {
              font-size: 17px;
              max-width: 110px;
              margin: 0 auto;
            }
          }
        }
      }
    }
  }

}
</style>
